// rbac/resource.ts
export const R = {
  dash: (dashId: string) => `dash:${dashId}`,
  widget: (dashId: string, widgetId: string) => `dash:${dashId}/widget:${widgetId}`,
  control: (dashId: string, widgetId: string, controlId: string) =>
    `dash:${dashId}/widget:${widgetId}/control:${controlId}`,
} as const;

// Dashboard IDs from the requirements
export const DASHBOARDS = {
  ESP_RECOMMENDATIONS: 'esp-recommendations',
  ESP_WELL_CHARTS: 'esp-well-charts',
  ESP_WELL_TESTS: 'esp-well-tests',
  GAPL_WELL_CHARTS: 'gapl-well-charts',
  GL_RECOMMENDATIONS: 'gl-recommendations',
  GL_WELL_CHARTS: 'gl-well-charts',
  GL_WELL_TESTS: 'gl-well-tests',
  INSTALLS: 'installs',
  PAGL_WELL_CHARTS: 'pagl-well-charts',
  PCP_WELL_CHARTS: 'pcp-well-charts',
  RL_WELL_CHARTS: 'rl-well-charts',
  RL_WELL_TESTS: 'rl-well-tests',
  FACILITY_WELL_CHARTS: 'facility-well-charts',
  NOTES_HISTORY: 'notes-history',
  ALARMS_DATA: 'alarms-data',
  ASSET_STATUS: 'asset-status',
  SETPOINTS: 'setpoints',
} as const;

// Widget IDs from the requirements
export const WIDGETS = {
  // ESP Well Charts widgets
  TIMESERIES_CHART: 'timeseriesChart',
  OIL_WATER_GAS_CHART: 'oilWaterGasChart',
  DEFAULT_WELL_TEST_TABLE: 'defaultWellTestTable',
  LAST_5_SHUTDOWNS: 'last5Shutdowns',
  ESP_WELL_STATUS: 'esp-wellStatus',
  VSD_SETTING_PROTECTION: 'vsdSettingProtection',
  SURFACE_POWER_OUTPUT: 'surfacePowerOutput',
  MOTOR_POWER: 'motorPower',
  TASK_DETAILS: 'taskDetails',
  WELL_NOTES: 'well-notes',
  WELL_COMMENTS: 'well-comments',
  NOTE_HISTORY: 'notesHistory',
  ALARMS_GRID: 'alarmsGrid',
  WELL_TEST_CHART: 'wellTestChart',
  WELL_TEST_SPLIT_CHART: 'wellTestSplitChart',
  WELL_TEST_TABLE: 'wellTestTable',
  ASSET_SCHEMATICS: 'assetSchematics',
  ASSET_COMMS: 'assetComms',
  ASSET_EXCEPTIONS: 'assetExceptions',
  ASSET_ALARMS: 'assetAlarms',
  ASSET_LAST_WELL_TEST: 'assetLastWellTest',
  ASSET_STATUS_REGISTERS: 'assetStatusRegisters',
  CARD_VIEWER: 'cardViewer',
  SETPOINT_MANAGER: 'setpointsManager',

  // Other widgets can be added here as needed
  ESP_RECOMMENDATIONS_CHARTS: 'espRecommendationsCharts',
  ESP_RECOMMENDATIONS_FREQUENCY_CHANGE: 'espRecommendationsFrequencyChange',
  ESP_RECOMMENDATIONS_PUMP_CHANGE: 'espRecommendationsPumpChange',
  ESP_RECOMMENDATIONS: 'espRecommendations',
} as const;
